import { render } from "./BizIcon.vue?vue&type=template&id=e9a973b6"
import script from "./BizIcon.vue?vue&type=script&lang=js"
export * from "./BizIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__